export default __webpack_public_path__ + "static/media/4.8e1aa56b.png";